export const masonryOptions = {
  transitionDuration: 0,
  isFitWidth: true,
  gutter: 10
};
